import React from "react";
import { Container, Row } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { PAGE_TITLES } from "../Common/constants";
import { ToastContainer, toast } from "react-toastify";

function InventoryBreadCrumb() {
  return (
    <React.Fragment>
      <div>
        <Container fluid>
          <BreadCrumb
            title={PAGE_TITLES.INVENTORY}
            pageTitle={PAGE_TITLES.INVENTORY}
            showBreadcrumb={false}
          />
          <ToastContainer position="top-center" />
        </Container>
      </div>
    </React.Fragment>
  );
}

export default InventoryBreadCrumb;
